import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);

    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      
      {/* Global inline CSS fix */}
      <style>
        {`
          .light .desc-html-content {
            color: #000;
          }

          .light .desc-html-content * {
            color: #000 !important;
          }

          .dark .desc-html-content {
            color: #fff;
          }

          .dark .desc-html-content * {
            color: #fff !important;
          }
        `}
      </style>

      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook
export const useTheme = () => {
  return useContext(ThemeContext);
};